import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "status-modal" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['status-overlay', _ctx.cssClass])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "message", {}, () => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.text), 1 /* TEXT */)
            ])
        ])
    ], 2 /* CLASS */));
}
